<template>
    <div class="swiperBox">
        <div class="goback"
             @click="goback"></div>
        <div class="swiper-name"
             v-html="bannerList[stu_inx].real_name"></div>
        <div class="swiper-time">{{bannerList[stu_inx].done_time|dateFormat('MM月DD日 hh:mm')}}</div>
        <swiper :options="swiperOption"
                ref="mySwiper"
                class='center'>
            <swiper-slide v-for="(img,index) in imgList"
                          :key='index'
                          v-if="bannerList[stu_inx].status!=0">
                <img class="thatImg"
                     :src="img" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
            <div class="swiper-scrollbar"
                 slot="scrollbar"></div>
        </swiper>
    </div>
</template>
<script type="text/ecmascript-6">
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
    data () {
        const self = this
        return {
            inx: this.$route.query.index,
            stu_inx: this.$route.query.stuindex,
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            swiperOption: {// 轮播配置
                loop: false,   // 循环滚动
                notNextTick: true,
                direction: 'horizontal',
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                paginationType: 'fraction',
                pagination: '.swiper-pagination',
                mousewheelControl: true,
                observeParents: true,
                onSlideNextEnd: function (swiper) {
                    self.handleClickSlide(swiper.activeIndex);
                },
                onSlidePrevEnd: function (swiper) {
                    self.handleClickSlide(swiper.activeIndex);
                },
            },
            bannerList: this.$store.state.chinese.picList,
            imgList: [],
        }
    },
    computed: {
        swiper () {
            return this.$refs.mySwiper.swiper;
        }
    },
    mounted () {
        this.inx = 1
        const that = this
        that.swiper.slideTo(this.inx, 0, false)

    },
    created () {
        if (!this.bannerList.length) {
            this.$router.go(-1)
        }
        this.imgList = this.bannerList[this.stu_inx].image_url;
    },
    methods: {
        goback () {
            this.$router.go(-1)
        },
        handleClickSlide (index) {
            // //console.log('当前点击索引:'+ index);
            this.inx = index
        }
    },
    components: {
        Swiper,
        SwiperSlide
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.goback {
    width: 18px / $ppr;
    height: 34px / $ppr;
    background-image: url("img/choose_back.png");
    background-size: 100% 100%;
    position: absolute;
    top: 1.4rem;
    left: 0.5rem;
    z-index: 102;
}
.swiper-slide {
    float: left;
}

.thatImg {
    max-width: 100%;
    max-height: 21rem;
    margin-top: 180px / $ppr;
}

.swiper-container {
    overflow: hidden;
    background: #333;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%;
}

.swiper-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .swiper-pagination {
        position: absolute;
        text-align: center;
        -webkit-transition: 0.3s opacity;
        -o-transition: 0.3s opacity;
        transition: 0.3s opacity;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        z-index: 10;
    }
}

/*点样式*/
.swiper-container .swiper-pagination {
    margin: 0 auto;
}
.swiper-pagination /deep/ span {
    display: inline-block;
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 50%;
    margin: 0 0.1rem;
    background: transparent !important;
}
.swiperBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}
.center {
    text-align: center;
}
.swiper-name {
    position: fixed;
    width: 100%;
    text-align: center;
    color: #fff;
    top: 56px / $ppr;
    font-size: 36px / $ppr;
    z-index: 101;
}
.swiper-time {
    position: fixed;
    width: 100%;
    text-align: center;
    color: #999;
    bottom: 146px / $ppr;
    font-size: 24px / $ppr;
    z-index: 101;
}
.swipers {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}
.swiper-pagination-fraction {
    color: #fff !important;
    font-size: 30px / $ppr !important;
    bottom: 80px / $ppr !important;
}
.swiper-pagination-fraction span {
    width: auto !important;
    height: auto !important;
    background: #333 !important;
}
</style>
